module.exports = function(){

    $(window).on('load', function(event) {
        event.preventDefault();
        $('html').addClass('is-loaded');
    });

    $(document).on('ready', function(event) {
        event.preventDefault();
        $('html').addClass('is-ready');
    });



}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/base/html-class.js